"use client"

import { useState } from "react"

interface ZoomEffectButtonProps {
  text: string
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  isInline?: boolean
  isLoading?: boolean
  loadingText?: string
  disabled?: boolean
  height?: string
  className?: string
}

export const ZoomEffectButton = ({
  text,
  onClick,
  isInline = false,
  className = "",
  isLoading = false,
  loadingText = "Đang gửi...",
  disabled = false,
  height: customHeight,
}: ZoomEffectButtonProps) => {
  const width = isInline ? "83.5px" : "164.5px"
  const height = customHeight || (isInline ? "42px" : "36px")
  const borderWidth = isInline ? "100.2px" : "197.4px"
  const borderHeight = customHeight ? `${parseFloat(customHeight) * 1.2}px` : isInline ? "50.4px" : "43.2px"

  const bgColor = "#18AF4E"
  const [isHovered, setIsHovered] = useState(false)

  const hasRoundedNone = className.includes("rounded-none")
  const borderRadius = hasRoundedNone
    ? "0"
    : isInline
      ? "0 4px 4px 0"
      : "4px"

  const baseStyle: React.CSSProperties = {
    position: "relative",
    color: "#fff",
    borderRadius,
    fontWeight: 600,
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "0",
    background: bgColor,
    transition: "filter 0.3s ease, background-color 0.3s ease",
    cursor: "pointer",
    zIndex: 2,
    overflow: "visible",
    width,
    height,
    fontSize: "14px",
    lineHeight: "14px",
  }

  const hoverStyle: React.CSSProperties = {
    ...baseStyle,
    filter: "brightness(1.1)",
  }

  const isDisabled = disabled || isLoading

  return (
    <div className="inline-block">
      <button
        type="button"
        onClick={onClick}
        disabled={isDisabled}
        onMouseEnter={() => !isDisabled && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={className}
        style={isHovered && !isDisabled ? hoverStyle : { ...baseStyle, opacity: isDisabled ? 0.6 : 1 }}
      >
        {isLoading ? loadingText : text}
        <span
          className="absolute top-1/2 left-1/2 pointer-events-none z-[-1] box-border transition-all"
          style={{
            border: `2px solid ${bgColor}`,
            borderRadius,
            width: borderWidth,
            height: borderHeight,
            opacity: isHovered ? 1 : 0,
            transformOrigin: "center center",
            transform: isHovered ? "translate(-50%, -50%) scale(0.8333)" : "translate(-50%, -50%) scale(1)",
            transition: "transform 0.6s cubic-bezier(0.6, 0, 0.1, 1), opacity 0.6s cubic-bezier(0.6, 0, 0.1, 1)",
          }}
        />
      </button>
    </div>
  )
}
